import React, { useCallback, useEffect, useState } from "react";

import {
  StyledBox,
  StyledBoxFragile,
  StyledExpiryBox,
  StyledExpiryContainer,
  StyledExpiryText,
  StyledFooter,
  StyledHeader,
  StyledHeaderLeft,
  StyledIDBox,
  StyledItem,
  StyledItemList,
  StyledLockerCard,
  StyledLockerTitle,
  StyledTypographyID,
  StyledTypographyName,
  StyledEmptyState,
} from "./style";
import CustomButton from "../common/button/CustomButton";
import locker from "../../assets/images/locker-icon.png";
import ellipse from "../../assets/images/ellipse.png";
import clock from "../../assets/svg/clock.svg";
import arrow from "../../assets/svg/arrow-up-right.svg";
import { StyledIcon } from "../orders-dashboard/style";
import theme from "../../theme";
import { Divider } from "@mui/material";
import { StyledWalletLabel } from "../common/navbar/style";
import { useDispatch, useSelector } from "react-redux";
import { VIRTUAL_LOCKER_GET_ITEM } from "../../actions/VirtualLockerAction";
import {
  canAddVirtualLockerItems,
  getLockerItemBlockReason,
} from "../../utils/orderCreateEligibility";
import ProductDetails from "../modals/product-details/ProductDetails";
import { useNavigate } from "react-router-dom";

const LockerInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openProductDetails, setOpenProductDetails] = useState(false);
  const handleOpenProductDetails = () => setOpenProductDetails(true);
  const handleCloseProductDetails = () => setOpenProductDetails(false);

  const lockerGetDetails = useSelector(
    (state) => state?.address?.virtualAddress
  );
  const hasLocker =
    Boolean(lockerGetDetails?.locker_id) &&
    !Array.isArray(lockerGetDetails);
  const expiryDate = new Date(lockerGetDetails?.locker_expiry_date);
  const today = new Date();

  let diffDays;
  if (!isNaN(expiryDate)) {
    const diffTime = expiryDate - today;
    diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  } else {
    diffDays = "Invalid date";
  }
  const getItemLocker = useCallback(
    (values) => {
      dispatch({
        type: VIRTUAL_LOCKER_GET_ITEM,
        payload: values,
      });
    },
    [dispatch]
  );
  const getItemData = useSelector(
    (state) => state?.virtual?.lockerGetList?.data
  );
  const { orderSummary, hasFetchedCustomerOrderList, recordList } = useSelector(
    (state) => state?.order ?? {}
  );
  const canAddItems = canAddVirtualLockerItems(
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList,
    lockerGetDetails
  );
  const addItemsBlockReason = getLockerItemBlockReason(
    lockerGetDetails,
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList
  );

  useEffect(() => {
    getItemLocker();
  }, [getItemLocker]);

  return (
    <StyledLockerCard>
      {/* Header */}
      <StyledHeader>
        <StyledHeaderLeft>
          <img loading="lazy" src={locker} alt="icon" />
          <StyledLockerTitle>VIRTUAL LOCKER</StyledLockerTitle>
        </StyledHeaderLeft>
        {lockerGetDetails?.locker_id && <StyledIDBox>
          <img
            loading="lazy"
            src={ellipse}
            alt="ellipse"
            width={8}
            height={8}
          />
          <StyledTypographyID>
            ID:{lockerGetDetails?.locker_id}
          </StyledTypographyID>
        </StyledIDBox>}
      </StyledHeader>

      <StyledItemList>
        {!hasLocker ? (
          <StyledEmptyState>Virtual locker not created</StyledEmptyState>
        ) : getItemData?.length ? (
          getItemData.map((item) => {
            return (
              <StyledItem
                key={item.id}
                selected={item.selected ? 1 : 0}
                space={item.fragile ? 1 : 0}
              >
                <StyledBox>
                  <StyledTypographyName>{item.shelf_no}</StyledTypographyName>
                  <StyledTypographyName>{item.product_name}</StyledTypographyName>
                </StyledBox>
                <StyledBoxFragile>
                  <StyledTypographyName>{item.quantity !== undefined && item.quantity !== null ? `x ${item.quantity}` : '-'}</StyledTypographyName>
                  {/* if need this content */}
                  {/* {item.fragile && (
                    <CustomChip
                      padding="4px 8px"
                      title="Fragile"
                      color={theme.palette.custom.danger}
                      background={theme.palette.custom.errorBg}
                      fontSize={theme.typography.chipColor.fontSize}
                    />
                  )} */}
                </StyledBoxFragile>
              </StyledItem>
            );
          })
        ) : (
          <StyledEmptyState>No items in locker</StyledEmptyState>
        )}
      </StyledItemList>
      <Divider />
      <StyledFooter>
        {hasLocker ? (
          <StyledExpiryBox>
            <img loading="lazy" src={clock} alt="icon" />
            <StyledExpiryContainer>
              <StyledWalletLabel>Locker Expiry</StyledWalletLabel>
              <StyledExpiryText>
                {!lockerGetDetails?.locker_expiry_date
                  ? "Inactive"
                  : diffDays <= 0
                    ? "Expired"
                    : `${diffDays} Days`}
              </StyledExpiryText>
            </StyledExpiryContainer>
            <StyledIcon src={arrow} alt="Arrow Icon" loading="lazy" />
          </StyledExpiryBox>
        ) : (
          <CustomButton
            btntype="primary"
            btnLabel="Create Locker"
            padding="8px 19px"
            fontSize={theme.typography.tinySmall.fontSize}
            onClick={() => navigate("/dashboard/locker-v2")}
          />
        )}
        <CustomButton
          btntype="warning"
          btnLabel="Add New"
          padding="8px 19px"
          fontSize={theme.typography.tinySmall.fontSize}
          disabled={!hasLocker || !canAddItems}
          title={!canAddItems ? addItemsBlockReason : undefined}
          onClick={() => {
            if (!canAddItems) return;
            navigate("/dashboard/locker/item");
          }}
        />
      </StyledFooter>
      {openProductDetails && (
        <ProductDetails
          open={openProductDetails}
          handleOpen={handleOpenProductDetails}
          handleClose={handleCloseProductDetails}
        />
      )}
    </StyledLockerCard>
  );
};

export default LockerInfo;
